__turbopack_context__.v({
  "animatePopoverIn": "multiselect-module__UI4cIa__animatePopoverIn",
  "animatePopoverOut": "multiselect-module__UI4cIa__animatePopoverOut",
  "popover-animations": "multiselect-module__UI4cIa__popover-animations",
});
